module.exports = {"231083100":"海林镇","231083101":"长汀镇","231083102":"横道镇","231083103":"山市镇","231083104":"柴河镇","231083105":"二道镇","231083106":"新安朝鲜族镇","231083107":"三道镇","231083400":"牡林工程公司街道","231083401":"柴河林机厂街道","231083402":"大海林林业局","231083403":"海林林业局","231083404":"柴河林业局","231083500":"海林农场","231083501":"山市种奶牛场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231083.json
// module id = 781
// module chunks = 0